export default {
  tabs: {
    travel: 'Travel',
    shaft: 'Switch',
  },
  shaftPanel: {
    title: 'Switch Selection',
    types: {
      CiYuPro: 'CiYu Pro',
      CiYuGaming: 'CiYu Gaming',
      WanCiWangRgb: 'Magnetic King RGB',
      WanCiWangPom: 'Magnetic King POM',
      WanCiWang: 'Magnetic King',
      TianWangEsports: 'Tianwang Magnetic - Esports',
      TianWangStandard: 'Tianwang Magnetic - Standard',
      KailhCiShen: 'Kailh Magnetic God',
      TaiShanGt: 'Taishan Magnetic GT',
      CiPo: 'Magnetic Amber',
      XingLan: 'Xinglan Magnetic',
      LiuLi: 'Liuli Magnetic',
    },
  },
  calibrationPanel: {
    backToItinerary: 'Back to Itinerary',
    introTip: 'Press each key fully for more accurate calibration',
    title: 'Switch Calibration',
    instructionPrefix: 'Click',
    instructionMiddle: 'to fully press each key that needs calibration. When a key turns',
    instructionSuccess: 'green, the key has been calibrated successfully',
    instructionSuffix: '. After calibration is complete, click',
    calibrationHint: 'You can now fully press each key that needs calibration',
    startCalibration: 'Start Calibration',
    saveCalibration: 'Save Calibration',
    adaptiveTitle: 'Adaptive Calibration',
    adaptiveDescription:
      'Adaptively adjusts calibration accuracy based on your environment and usage habits to ensure stable performance',
    adaptiveWarning: 'Turning this off increases the risk of missed and false triggers',
  },
  keyboardPanel: {
    selectAll: 'Select All',
    invertSelection: 'Invert Selection',
    selectWASD: 'WASD',
    selectAZ: 'A-Z',
    selectionToast: 'Right-click to clear the selection',
  },
  arcGaugeSlider: {
    title: 'Key Travel Visualization',
    calibrate: 'Calibration',
    referenceOnly: 'Illustration only. Values are for reference.',
  },
  itineraryTrigger: {
    triggerTravel: 'Actuation Point',
    initialTriggerTravel: 'Initial Actuation Point',
    rtMode: 'RT Mode',
    rtModeTooltip: 'You can choose any key on the virtual keyboard to enable RT mode',
    rtModeDescription: 'Adjusts actuation and reset distance based on key input.',
    continuousTrigger: 'Continuous Rapid Trigger',
    continuousTriggerTooltip: 'Enable RT mode to configure continuous rapid trigger',
    continuousTriggerDescription:
      'When enabled, rapid trigger remains active until the key is fully released. When disabled, it stops at the actuation point during release.',
  },
  bottomDeadZone: {
    title: 'Bottom Deadzone',
    description: 'Automatically limits bottom reset distance for improved stability.',
  },
  deadZone: {
    title: 'Deadzone Settings',
    description: 'Top deadzone reduces accidental presses; bottom deadzone reduces missed inputs.',
    top: 'Top',
    bottom: 'Bottom',
  },
  rtSensitivityTrigger: {
    triggerSensitivity: 'RT Trigger Sensitivity',
    triggerTooltip:
      'Triggers when the press exceeds the configured sensitivity. After the key is released past the reset value, pressing again will trigger at the configured sensitivity',
    linkedMode: 'Linked Mode',
    unlinkedMode: 'Unlinked Mode',
    resetSensitivity: 'RT Reset Sensitivity',
    resetTooltip: 'Resets when the release exceeds the configured sensitivity value',
    switchKey: 'RT Switch',
    custom: 'Custom',
    precisionAdjust: 'RT Precision',
  },
}
